import { render, staticRenderFns } from "./WidgetLibrary.vue?vue&type=template&id=64af006c&scoped=true&"
import script from "./WidgetLibrary.vue?vue&type=script&lang=js&"
export * from "./WidgetLibrary.vue?vue&type=script&lang=js&"
import style0 from "./WidgetLibrary.vue?vue&type=style&index=0&id=64af006c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64af006c",
  null
  
)

export default component.exports